var api = function(config, client) {

    let login = (username, password) => {
        return client.login(username, password)
    }

    let getProfile = () => {
        return client.get('/api/company/me')
    }

    let getStatistics = (settlementId) => {
        return client.get('/api/settlement/' + settlementId + '/statistics')
    }

    let getRevenue = (settlementId, startDate, endDate) => {
        return client.get('/api/settlement/' + settlementId + '/revenue?startDate=' + startDate + '&endDate=' + endDate)
    }

    let getDateRevenue = (settlementId, date) => {
        return client.get('/api/orders/date/' + date)
    }

    let getOrder = (orderId) => {
        return client.get('/api/orders/' + orderId)
    }
    
    let getProducts = (settlementId) => {
        return client.get('/api/' + settlementId + '/categorized-products');
    }

    let getProductById = (productId) => {
        return client.get('/api/product/' + productId);
    }

    let deleteProduct = (productId) => {
        return client.delete('/api/product/' + productId);
    }

    let createProduct = (productDTO) => {
        return client.post('/api/products', productDTO);
    }

    let updateProduct = (productId, productDTO) => {
        return client.put('/api/products/' + productId, productDTO);
    }

    let getCategories = (settlementId) => {
        return client.get('/api/settlement/' + settlementId + '/categories');
    }

    let getAdditions = (settlementId) => {
        return client.get('/api/settlement/' + settlementId + '/additions')
    }

    let getAdditionById = (itemId) => {
        return client.get('/api/addition/' + itemId);
    }

    let deleteAddition = (itemId) => {
        return client.delete('/api/addition/' + itemId);
    }

    let createAddition = (itemDTO) => {
        return client.post('/api/additions', itemDTO);
    }

    let updateAddition = (itemId, itemDTO) => {
        return client.put('/api/additions/' + itemId, itemDTO);
    }

    let getTaxLevels = () => {
        return client.get('/api/tax-levels');
    }

    // Expose API methods:
    return {
        login: login,
        getProfile: getProfile,
        getStatistics: getStatistics,
        getRevenue: getRevenue,
        getDateRevenue: getDateRevenue,
        getProducts: getProducts,
        deleteProduct: deleteProduct,
        getProductById: getProductById,
        createProduct: createProduct,
        updateProduct: updateProduct,
        getCategories: getCategories,
        getAdditions: getAdditions,
        deleteAddition: deleteAddition,
        updateAddition: updateAddition,
        createAddition: createAddition,
        getAdditionById: getAdditionById,
        getTaxLevels: getTaxLevels,
        getOrder: getOrder
    }

}

export default api